<template>
	<div class="slot">
		<div class="card-wrap"
			v-droppable="current_slot"
			@mouseenter="enter_hover(current_slot)"
			@mouseleave="leave_hover()"
		>
			<transition name="draw">
				<card v-if="current_slot.card" :card="current_slot.card" />
			</transition>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import interact from 'interactjs'
import Card from '@/components/game/card'
import HeroMixin from '@/mixins/hero'

export default {
	name: 'board-slot',
	mixins: [ HeroMixin ],
	data: function() {
		return {
			
		}
	},
	props: [ 'current_slot', 'visible', 'fog' ],
	computed: Object.assign(mapGetters([ 'current', 'game' ]), {
	}),
	methods: {
		row_class: function(row) {
			var temp = []
			if (this.visible) temp.push('visible')
			if (row.id == this.current.row + 1) temp.push('on-top')
			return temp
		},
		enter_hover: function() {
			if (this.current_slot.card && this.visible && !this.current_slot.card.no_hover && !this.fog) this.$store.commit('SET_HOVER_CARD', { card: this.current_slot.card })
		},
		leave_hover: function() {
			if (this.game.hover_card) this.$store.commit('SET_HOVER_CARD', { card: false })
		},
		drop_valid: function() {
			return (this.current_slot.card && this.current_slot.row === this.current.row && Math.abs(this.current_slot.position - this.current.position) <= 1)
		},
	},
	directives: {
		droppable: {
			inserted: function(el, binding, vnode) {
				var self = vnode.context
				interact(el).dropzone({
					accept: '.hero',
					overlap: 0.3,
					ondragenter: function (event) {
						if (self.drop_valid(self.current_slot)) {
							self.enter_hover(self.current_slot)
							event.target.classList.add('dropping')
						}
					},
					ondragleave: function (event) {
						event.target.classList.remove('dropping')
						self.leave_hover()
					},
					ondrop: function (event) {
						event.target.classList.remove('dropping')
						var draggable = event.relatedTarget
						if (self.drop_valid(self.current_slot)) {
							event.target.classList.remove('dropping')
							var x = 0
							if (self.current_slot.position == 0) x = -(draggable.offsetWidth + 8)
							if (self.current_slot.position == 2) x = (draggable.offsetWidth + 8)
							var y = -(draggable.offsetHeight + 8)
							draggable.style.webkitTransform = draggable.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1)'
							draggable.setAttribute('data-x', x)
							draggable.setAttribute('data-y', y)
							Sounds.play('card')
							
							self.$nextTick(function() {
								self.leave_hover()
								self.$store.dispatch('play_card', { card: self.current_slot.card, position: self.current_slot.position })
							})
						} else {
							self.back_to_position(draggable)
						}
					}
				});
			}
		}
	},
	components: { Card }
}
</script>

<style lang="stylus">
@import '../../../assets/css/app'

.slot
	display inline-block
	width card_width
	height card_height
	margin 4px
	// background-color alpha(#000, 25%)
	border-radius 6px
	.card-wrap
		height 100%
		width 100%
		&.dropping
			&:after
				background-color alpha(orange, 25%)
		&:after
			content ''
			position absolute
			left 0px
			top 0px
			right 0px
			bottom 0px
			border-radius 6px
		.card
			&.monster-attack
				z-index 10
				animation 960ms monster_attack
				animation-delay 750ms
	.slot-id
		position absolute
		right 0
		bottom 0
		padding 0px 8px
		background-color red
		color #fff


</style>
